import { render, staticRenderFns } from "./ShowComplex.vue?vue&type=template&id=60cc4d30&scoped=true"
import script from "./ShowComplex.vue?vue&type=script&lang=js"
export * from "./ShowComplex.vue?vue&type=script&lang=js"
import style0 from "./ShowComplex.vue?vue&type=style&index=0&id=60cc4d30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cc4d30",
  null
  
)

export default component.exports